import React, { FC } from 'react';
import { create } from 'zustand';

export enum SettingsPages {
  Root = 0,
  TextLocale = 1,
  Speed = 2,
  MediumLocale = 3,
  Subtitles = 4,
  DarkMode = 5,
  SubtitleLocale = 6
}

interface Store {
  page: SettingsPages;
  open: boolean;
  setPage(page: SettingsPages): void;
  toggle(open?: boolean): void;
}

// export const { Provider: SettingsProvider, useStore: useSettingsStore } =
//   createContext<StoreApi<Store>>();

export const useSettingsStore = create<Store>((set, get) => ({
  page: SettingsPages.Root,
  open: false,
  setPage: page => set({ page }),
  toggle: open => set({ open: open === undefined ? !get().open : open })
}));

export const SettingsProvider: FC = ({ children }: { children: any }) => <>{children}</>;
